import React from 'react';
import './RiskButton.scss';

function RiskButton(props) {
    // note: not using the Button component because this has the ripple effect which is not needed here.
    // Also this button has an active feature (which changes it's appearance).

    let style;

    if (props.active) {
        style = {
            color: 'white',
            borderColor: props.buttonColor,
            backgroundColor: props.buttonColor
        };
    } else {
        style = {
            color: props.buttonColor,
            borderColor: props.buttonColor,
            backgroundColor: 'white'
        };
    }

    return (
        <div className="risk-button" style={style}>
            {props.buttonText}
        </div>
    );
}

export default RiskButton;
